module.exports = __webpack_public_path__ + "img/gb9116_11_b.prt.ce676ac8.jpg";